import * as Sentry from '@sentry/react';

export type SentryAppName = 'admin' | 'p2e' | 'teacher';

export interface InitSentryOptions {
  app: SentryAppName;
  dsn: string | undefined;
  environment: string;
  release?: string;
  tracesSampleRate?: number;
  replaysOnErrorSampleRate?: number;
  sendDefaultPii?: boolean;
  enabled?: boolean;
}

export const initSentry = ({
  app,
  dsn,
  environment,
  release,
  tracesSampleRate = 0.1,
  replaysOnErrorSampleRate = 1.0,
  sendDefaultPii = true,
  enabled,
}: InitSentryOptions): void => {
  const isEnabled = enabled ?? (Boolean(dsn) && environment !== 'development' && environment !== 'local');
  if (!isEnabled || !dsn) return;

  Sentry.init({
    dsn,
    environment,
    release,
    sendDefaultPii,
    initialScope: { tags: { app } },
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true }),
    ],
    tracesSampleRate,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate,
    beforeSend(event, hint) {
      const error = hint?.originalException;
      if (error instanceof Error) {
        if (error.name === 'AbortError') return null;
        if (error.message?.includes('Login required')) return null;
      }
      return event;
    },
  });
};

export const setSentryUser = (user: { id: string; email?: string | null }): void => {
  Sentry.setUser({ id: user.id, email: user.email ?? undefined });
};

export const clearSentryUser = (): void => {
  Sentry.setUser(null);
};

export { Sentry };
